export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8526.12f83484.jpg";